import apiClient from './apiClient'


const getLabels = (tenant) => {
  return apiClient.get(`/${tenant}/Project/Labels`)
}

const createLabel = (tenant, label) => {
  return apiClient.post(`/${tenant}/Project/Label`, label)
}

const updateLabel = (tenant, id, label) => {
  return apiClient.put(`/${tenant}/Project/Label/${id}`, label)
}

const deleteLabel = (tenant, id) => {
  return apiClient.delete(`/${tenant}/Project/Label/${id}`)
}


export default {
  getLabels,
  createLabel,
  updateLabel,
  deleteLabel
}
